module.exports = __webpack_public_path__ + "d1c86c4d49cc7e32290a7a565b9b47a9.png";